<template>
  <v-container class="px-8 py-0 no-applicable error-page">
    <v-row class="ma-0 pa-0 inner-padding">
      <v-col cols="12" class="pa-0">
        <div class="img-wrap mx-auto text-center">
          <v-img src="@/assets/img/no_applicable.png"></v-img>
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-0 pa-0 mt-5">
      <v-col cols="12" class="pa-0 text-center page-title" v-html="text" />
    </v-row>
    <v-row v-if="toMainBtn" class="ma-0 mt-6 pa-0 justify-center">
      <v-col cols="12" class="ma-0 pa-0 btn-wrap">
        <v-btn
          block
          elevation="0"
          color="darkGrey"
          class="btn-move"
          @click="toMain"
          ><span class="white--text"
            ><v-icon class="mr-2">mdi-home-variant-outline</v-icon
            >{{ $t('메인 페이지로 이동') }}
          </span></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '해당사항이 아닙니다:-)',
    },
    toMainBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toMain() {
      this.$router.push('/main');
    },
  },
  components: {},
};
</script>

<style scoped>
/* _error.scss */
</style>
